import { create } from "zustand";

const useSimulatorsStore = create((set) => ({
  requiredInfoForSimulation: {},
  setRequiredInfoForSimulation: (data) =>
    set({ requiredInfoForSimulation: data }),
  products: [],
  setProducts: (data) => set({ products: data }),
  getProductsByGroup: (group) => {
    const filteredProducts = useSimulatorsStore
      .getState()
      .products.filter((product) => product.grupoProdutos === group);
    return filteredProducts;
  },
  groupProductsByGroup: () => {
    const groupedProducts = useSimulatorsStore
      .getState()
      .products.reduce((acc, product) => {
        const group = product.grupoProdutos;
        acc[group] = acc[group] || [];
        acc[group].push(product);
        return acc;
      }, {});
    const resultArray = Object.values(groupedProducts);

    return resultArray;
  },
  removeProductById: (id) => {
    set((state) => ({
      products: state.products.filter((product) => product.id !== id),
    }));
  },
}));

export default useSimulatorsStore;
